export default __webpack_public_path__ + "static/media/pic2.2e909308.jpg";